<template>
	<input v-if="visible" type="checkbox" v-model="value" :class="clazz" :style="style" :disabled="ro" v-bind="tabindexBinding()"/>
</template>

<script setup lang="ts">
import useEditor, {type EditorProps, editorProps} from "./Editor";
import type {Checkbox} from "@t/fd/editor/Checkbox";

const uprops = defineProps({ ...editorProps });
const props = uprops as EditorProps;

const { visible, value, clazz, style, ro, tabindexBinding } = useEditor(props);
</script>

<style>

</style>
